<template>
  <div id="page" :style="{ backgroundImage: 'url(' + this.url + ' )' }">
    <img
      :src="images.top"
      style="width: 100%; float: center; margin-top: 40px"
    />
    <div style="width: 100%; height: 40px; background-color: white"></div>

    <div style="width: 100%; height: 75px; background-color: white">
      <div
        style="
          font-family: PingFangSC-Medium;
          font-size: 25px;
          margin-top: 0px;
         text-align: center;
        "
      >
        三、胜任力潜质报告
      </div>
    </div>

    <div style="width: 100%; height: 36px; background-color: white;margin-top:870px">

    </div>

    <div id="footer">
      <span id="footer-red"
        >{{page}}</span
      >
    </div>
  </div>
</template>

<script>
export default {
  props: ["model", "url","page"],
  data() {
    return {
      images: {
        top: require("@/views/CNBM/images/top.png"),
        youshi: require("@/views/CNBM/images/youshi.png"),
        huojian: require("@/views/CNBM/images/huojian.png"),
      },
    };
  },
  mounted() {
    if (this.model) {
      //   this.url =
      //     "https://cdn.acmcoder.com/files/2022/cnbm/competency/" +
      //     this.model.name +
      //     "/" +
      //     this.model.name +
      //     "-胜任力潜质报告_" +
      //     1 +
      //     ".png";
    }
  },
  watch: {},
  methods: {},
};
</script>
<style lang='scss' scoped>
</style>



// WEBPACK FOOTER //
// src/views/CNBMTalent/pages/page-four.vue